import { useTranslation } from 'react-i18next';

/**
 * Hook to determine if the current language is RTL
 * @returns {boolean} True if the current language is RTL
 */
export const useIsRTL = (): boolean => {
  const { i18n } = useTranslation();
  return i18n.language === 'fa';
};
